@let isLoading = $loading | async;
<app-in-play-loader [show]="markets.length === 0 && isLoading || isLoadingStatus()" />
@if (markets.length > 0) {
  @for (each of markets; track each.key) {
    <app-sport-highlights [data]="each" [showHeader]="false" />
  }
}
@if (markets.length === 0 && !isLoading && !isLoadingStatus()) {
  <app-status-alert
    [config]="{
      title: 'No Markets Available',
      subtitle: 'There are no events available at the moment. Please check back later.',
      type: 'info',
      mode: 'block',
      icon: 'dynamic_feed'
    }"
  />
}
